// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { IADXEx } from './iADXEx';
export const iADX = 'iADX';
export class IADX extends IADXEx {
    constructor(maPeriod, maMode) {
        super(maPeriod, PriceType.Close, maMode);
    }
    get Name() {
        return iADX;
    }
}
